interface State {
  location: any,
  services: any,
  timetable: any,
  lastMinute: any,
  settings: any,
  images: any,
  integrations: any,
  tabs: any,
  colours: any,
  slug: any,
  menu: any,
  domain: any,
  customPages: any
}

export const useLocationStore = defineStore('location', {
  state: () => {
    return {
      location: null,
      services: null,
      timetable: null,
      lastMinute: null,
      settings: null,
      images: null,
      integrations: null,
      tabs: null,
      colours: null,
      slug: null,
      menu: null,
      domain: null,
      customPages: null
    } as State
  },
  actions: {
    setServices(services) {
      this.services = services
    },
    setTimetable(timetable) {
      this.timetable = timetable
    },
    setLastMinute(lastMinute) {
      this.lastMinute = lastMinute
    },
    setLocationInfo({ location, settings, images, integrations, tabs, colours, slug, domain, menu, customPages }) {
      this.location = location
      this.settings = settings
      this.images = images
      this.integrations = integrations
      this.tabs = tabs
      this.colours = colours
      this.slug = slug
      this.menu = menu
      this.customPages = customPages
      this.domain = domain
    },
    async getServices() {
      if (!this.services) {
        const { $api } = useNuxtApp()
        const response = await $api.booking.services()

        this.setServices(response.services)

        return response
      }
    },
    async getTimetable() {
      const { $api } = useNuxtApp()
      const response = await $api.booking.timetable()

      this.setTimetable(response)

      return response
    },
    async getLastMinute() {
      const { $api } = useNuxtApp()
      const response = await $api.booking.lastMinute()
      
      this.setLastMinute(response)

      return response
    },
  },
  getters: {
    /* getServices(state: any) {
      return state.services
    }, */
    getAllServices(state: any) {
      const allServices = []
  
      if (state.services) {
        for (let i = 0; i < state.services.categories.length; ++i) {
          const category = state.services.categories[i]
          for (let j = 0; j < category.services.length; ++j) {
            allServices.push(category.services[j])
          }
        }
      }
      return allServices
    },
    getServiceById: state => (id: any) => {
      if (state.services && state.services.categories) {
        for (let i = 0; i < state.services.categories.length; ++i) {
          const category = state.services.categories[i]
          for (let j = 0; j < category.services.length; ++j) {
            if (category.services[j].id == id) return category.services[j]
          }
        }
      }
      
      return null
    }
  },
  // persist: true,
});
